export default __webpack_public_path__ + "static/media/aboutimg5.55d89451.jpg";